<div class="invoice-box">
    <table>
        <tbody>
            <tr class="top">
                <td colspan="2">
                    <table>
                        <tbody>
                            <tr>
                                <td class="title">
                                    <img src="../../assets/images/bim-logo.png" style="width:150px; height:auto" alt="Business in Maharashtra">
                                </td>
                                <td>
                                    Invoice #: 25<br> Created: January 21, 2020<br> Due: February 1, 2020
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
            <tr class="information">
                <td colspan="2">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    Townhub , Inc.<br> USA 27TH Brooklyn NY<br>
                                    <a href="#" style="color:#666; text-decoration:none">JessieManrty&COPY;domain.com</a>
                                    <br>
                                    <a href="#" style="color:#666; text-decoration:none">+4(333)123456</a>
                                </td>
                                <td>
                                    Jessie Manrty<br>
                                    <a href="#" style="color:#666; text-decoration:none">yourmail&COPY;domain.com</a>
                                    <br>
                                    <a href="#" style="color:#666; text-decoration:none">+7(123)987654</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
            <tr class="heading">
                <td>
                    Payment Method
                </td>
                <td>
                    Check #
                </td>
            </tr>
            <tr class="details">
                <td>
                    Visa ending **** 4242
                </td>
                <td>
                    Check
                </td>
            </tr>
            <tr class="heading">
                <td>
                    Option
                </td>
                <td>
                    Details
                </td>
            </tr>
            <tr class="item">
                <td>
                    Hotel
                </td>
                <td>
                    Premium Plaza Hotel
                </td>
            </tr>
            <tr class="item">
                <td>
                    Room Type
                </td>
                <td>
                    Standard Family Room $81
                </td>
            </tr>
            <tr class="item ">
                <td>
                    Days
                </td>
                <td>
                    3
                </td>
            </tr>
            <tr class="item ">
                <td>
                    Persons
                </td>
                <td>
                    3
                </td>
            </tr>
            <tr class="item last">
                <td>
                    Taxes
                </td>
                <td>
                    $12
                </td>
            </tr>
            <tr class="total">
                <td></td>
                <td style="padding-top:50px;">
                    Total: $690.00
                </td>
            </tr>
        </tbody>
    </table>
</div>
<a href="javascript:window.print()" class="print-button">Print this invoice</a>